<template>
  <v-container class="pa-0 pa-sm-auto">
    <v-container class="pa-0">
      <v-row class="flex-wrap pa-0 ma-0">
        <v-col class="text-left text-sm-right px-0">
          <v-btn-toggle v-model="filterByPersonIds" group active-class="primary--text">
            <div class="my-2 d-flex flex-nowrap">
              <v-btn
              
                v-for="person in personsWithFullCountriesStatistics"
                :key="person.id"
                height="50px"
                :value="person.id"
                class="px-1 px-sm-3"
              >
                <PersonAvatar
                  :avatar-filename="person.avatar_filename"
                  :avatar-height="avatarHeight"
                ></PersonAvatar>
                {{
                countriesVisited[person.id] &&
                countriesVisited[person.id].visits
                ? Object.keys(countriesVisited[person.id].visits).length
                : 0
                }}
              </v-btn>
            </div>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="pa-0 ma-0">
      <CountriesTable
        :countries="countries"
        :filter-by-person-ids="filterByPersonIds"
        :countries-visited="countriesVisited"
      ></CountriesTable>
    </v-card>
  </v-container>
</template>

<script>
import APIService from '@/apiservices/APIService.js'

import CountriesTable from '@/components/CountriesTable'

import PersonAvatar from '@/components/PersonAvatar.vue'

import { authComputed } from '@/store/helpers.js'

export default {
  name: 'CountriesPage',
  components: {
    CountriesTable,

    PersonAvatar
  },
  methods: {
    filterByPerson(personId) {
      this.filterByPersonIds = personId
    },

    getUniqCountriesNumber(countries) {
      const distArr = [...new Set(countries.map(x => x.country_name))]

      return distArr.length
    }
  },

  computed: {
    ...authComputed,
    avatarHeight() {
      if (this.$vuetify.breakpoint.name == 'xs') return '40px'

      return '45px'
    },

    mungedCountries() {
      return this.countries.map(v => {
        return {
          ...v,
          travel_year: new Date(v.in_date).getFullYear()
        }
      })
    }
  },

  data() {
    return {
      countries: [],
      journeys: [],

      filterByPersonIds: this.$store.getters.loggedUserPersonId,
      countriesVisited: {},

      personsWithFullCountriesStatistics: []
    }
  },

  created() {

    APIService.getPersonsWithFullCountriesStatistics()
      .then(response => {
        
        this.personsWithFullCountriesStatistics = response.data
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })

    APIService.getTrips()
      .then(response => {
        /*
        this.journeys = response.data

        this.countries = [].concat.apply(
          [],
          this.journeys.map(x => x.countries)
        )
        */
        
        this.countries = response.data

        for (var i = 0; i < this.personsWithFullCountriesStatistics.length; i++) {
          
          var id = parseInt(this.personsWithFullCountriesStatistics[i].id)
          var visits = {}
          var nights = {}
          this.countries
            .filter(function(obj) {
              return obj.persons.map(x => x.id).includes(id)
            })
            .forEach(function(x) {
              
              visits[x.country_name] = (visits[x.country_name] || 0) + 1
              nights[x.country_name] =
                (nights[x.country_name] || 0) + x.duration + 1
            })
          this.countriesVisited[id] = { visits: visits, nights: nights }
          
        }

        this.countries = this.mungedCountries
      })

      .catch(error => {
        console.log('There was an error:', error.response)
      })

    
  },
  destroyed() {
    console.log('Countries page destroyed')
  }
}
</script>
